import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { tap, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { BoSpinnerService } from 'src/@core/shared';
import { environment } from 'src/environments/environment';
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService,
    private router: Router,
    private spinner: BoSpinnerService) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(request.url.indexOf("getNotifications")<0)
      this.spinner.show();
    if (request.url.indexOf(environment.baseUrl) > -1) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.auth.GetAccessToken()}`
        },
        withCredentials: false
      });
    } else {
      request = request.clone();
    }
    return next.handle(request)
      //.pipe(tap(() => this.spinner.hide()));
      .pipe(
        tap(result => {
          if (result instanceof HttpResponse) {
            this.spinner.hide();
          }
        }),
          catchError(error => {
            this.spinner.hide();
            if (error instanceof HttpErrorResponse) {
              if (error.status === 401) {
                this.auth.clearToken();
                this.router.navigate(['login'], { queryParams: { returnUrl: window.location.pathname } });
              }
              return throwError(error);
            }
          }),
        );
  }
}
